module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "campus-dashboard"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', [_vm._v("Paths / Focuses")]), _vm._v(" "), _c('VuePerfectScrollbar', {
    staticClass: "scroll-area"
  }, [(_vm.paths) ? _c('ul', {
    staticClass: "scroller"
  }, _vm._l((_vm.paths), function(path) {
    return _c('li', {
      class: {
        'selected': _vm.selectedPath === path.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectedPath = path.id;
          _vm.selectedCourses = path.courses
        }
      }
    }, [_c('span', [_vm._v(_vm._s(path.name))])])
  })) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', [_vm._v("Courses")]), _vm._v(" "), _c('VuePerfectScrollbar', {
    staticClass: "scroll-area"
  }, [(_vm.courses) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedCourses.length > 0),
      expression: "selectedCourses.length > 0"
    }],
    staticClass: "scroller"
  }, _vm._l((_vm.courses), function(course) {
    return (_vm.selectedCourses.indexOf(course.associated.id) > -1) ? _c('li', {
      class: {
        'selected': _vm.selectedInstance === course.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectedInstance = course.id;
          _vm.selectedCourse = course.associated.courseId
        }
      }
    }, [_vm._v("\n                           " + _vm._s(course.associated.name) + "\n                        ")]) : _vm._e()
  })) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', [_vm._v("Lessons")]), _vm._v(" "), _c('VuePerfectScrollbar', {
    staticClass: "scroll-area"
  }, [(_vm.lessons) ? _c('ul', {
    staticClass: "scroller"
  }, _vm._l((_vm.lessons), function(lesson) {
    return _c('li', {
      class: {
        'selected': _vm.selectedLesson === lesson.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectLesson(lesson.id, lesson.week)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(lesson.title) + "                                            \n                        ")])
  })) : _vm._e()])], 1)])]), _vm._v(" "), (_vm.selectedLesson) ? _c('div', [_c('video-player')], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Video Library")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4730c8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CampusDashboard.vue
// module id = 2120
// module chunks = 2